"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represents Button that is rendered for, and interfaces with, a specific Authenticator app.
 */
class Authenticator {
    /**
     * @param chains     This represents each of the chains that the dapp provides support for.
     *
     * @param options    Optional argument that is intended for Authenticator specific options.
     */
    constructor(chains, options) {
        this.chains = chains;
        this.options = options;
    }
}
exports.Authenticator = Authenticator;
